// FAQController
app.controller('FAQController', ['$scope', '$http', 'WdHttpService',
    function($scope, $http, WdHttpService) {

        // Init 
        $scope.init = async function() {
            await $scope.fetchAdviserSiteDetails();
            // FAQ Details
            $scope.showFaqCategory = true;
            $scope.showFAQDetails = false;
            $scope.faqDetailsArr = [];
            $scope.faqRelatedArr = [];
            $scope.faqList = [];
            $scope.faqColumn1List = [];
            $scope.faqColumn2List = [];
            $scope.faqColumn3List = [];
            $scope.faqColumn4List = [];

            //call the adviser page details
            $scope.wealthBasketType = 'Advisor';
            $scope.adviserDetails = await WdHttpService._get_entity_page_details({ adviserUsername: $scope.distributorUsername });
            if ('custom:metadata' in $scope.adviserDetails) {
                if ("isRIA" in $scope.adviserDetails['custom:metadata'])
                    if ($scope.adviserDetails['custom:metadata'].isRIA == 'RA')
                        $scope.wealthBasketType = 'Research Analyst';
            }

            $(function() {
                $('#faq').addClass('active');
            });


            $scope.faqs();
        }

        $scope.showFAQDetailsClick = function(faqData) {
            $scope.showFaqCategory = false;
            $scope.showFAQDetails = true;
            $scope.faqDetailsArr = [];
            $scope.faqDetailsArr.push(faqData);

            var title = $scope.faqDetailsArr[0].title;
            angular.forEach($scope.faqCategory, function(value, key) {
                if (title != value.title) {
                    $scope.faqRelatedArr.push(value);
                }
            });
        }

        $scope.backToFaq = function() {
            $scope.showFaqCategory = true;
            $scope.showFAQDetails = false;
        }

        $scope.faqs = function() {
            $http({
                method: 'GET',
                url: $scope.faqUrl,
                headers: { 'Content-Type': 'application/json' }
            }).then(function(response) {
                //gettingStarted
                var gettingStarted = response.data.gettingStarted;
                angular.forEach(gettingStarted, function(value, key) {
                    angular.forEach(value, function(Fqvalue, Fqkey) {
                        var getStartKey = Fqkey;
                        $scope.faqColumn1List.push({
                            "question": getStartKey,
                            "answer": Fqvalue
                        });
                    });
                });
                //understandingWealthbaksets
                var understandingWealthbaksets = response.data.understandingWealthbaksets;
                angular.forEach(understandingWealthbaksets, function(value, key) {
                    angular.forEach(value, function(Fqsvalue, Fqskey) {
                        var getStartKeya = Fqskey;
                        $scope.faqColumn2List.push({
                            "question": getStartKeya,
                            "answer": Fqsvalue
                        });
                    });
                });
                //aboutAdvisor
                var aboutAdvisor = response.data.aboutAdvisor;
                angular.forEach(aboutAdvisor, function(value, key) {
                    angular.forEach(value, function(Fqevalue, Fqekey) {
                        var getStartKeye = Fqekey;
                        $scope.faqColumn4List.push({
                            "question": getStartKeye,
                            "answer": Fqevalue
                        });
                    });
                });
                //investingMadeSimple
                var investingMadeSimple = response.data.investingMadeSimple;
                angular.forEach(investingMadeSimple, function(value, key) {
                    angular.forEach(value, function(Fqivalue, Fqikey) {
                        var getStartKeys = Fqikey;
                        $scope.faqColumn3List.push({
                            "question": getStartKeys,
                            "answer": Fqivalue
                        });
                    });
                });
            }, function(error) {
                $scope.error = error;
            });
        }

        $scope.clickGettingStarted = function() {
            $('html, body').animate({
                scrollTop: $("#gettingStarted").offset().top
            }, 2000);
        }

        $scope.clickInvestingWealthbasket = function() {
            $('html, body').animate({
                scrollTop: $("#investingWealthbaskets").offset().top
            }, 2000);
        }

        $scope.clickUnderstandingWealthbasket = function() {
            $('html, body').animate({
                scrollTop: $("#understandingWealthbasket").offset().top
            }, 2000);
        }

        $scope.clickAboutAdvisor = function() {
            $('html, body').animate({
                scrollTop: $("#aboutAdvisor").offset().top
            }, 2000);
        }
    }
]);